import { render } from "./gc-s-icon.vue?vue&type=template&id=48dbbfb8&scoped=true"
import script from "./gc-s-icon.vue?vue&type=script&lang=js"
export * from "./gc-s-icon.vue?vue&type=script&lang=js"

import "./gc-s-icon.vue?vue&type=style&index=0&id=48dbbfb8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dbbfb8"]])

export default __exports__